(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myvitahue-landing"]) return;
  try {
    
(function () {
  var faqButtons = document.querySelectorAll('.mvh-landing .faq-question');
  faqButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var isActive = item.classList.contains('active');
      document.querySelectorAll('.mvh-landing .faq-item').forEach(function (i) {
        i.classList.remove('active');
        var q = i.querySelector('.faq-question');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
      if (!isActive) { item.classList.add('active'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
  var fadeEls = document.querySelectorAll('.mvh-landing .fade-in');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    fadeEls.forEach(function (el) { obs.observe(el); });
  } else { fadeEls.forEach(function (el) { el.classList.add('visible'); }); }
  var navLinks = document.querySelectorAll('.mvh-landing .anchor-nav-list a');
  var sections = [];
  navLinks.forEach(function (link) {
    var href = link.getAttribute('href');
    if (href && href.startsWith('#')) { var s = document.querySelector(href); if (s) sections.push({ el: s, link: link }); }
  });
  if (sections.length > 0) {
    var sObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var ml = null; sections.forEach(function (s) { if (s.el === entry.target) ml = s.link; });
        if (ml && entry.isIntersecting) { navLinks.forEach(function (l) { l.classList.remove('active'); }); ml.classList.add('active'); }
      });
    }, { threshold: 0.2, rootMargin: '-60px 0px -40% 0px' });
    sections.forEach(function (s) { sObs.observe(s.el); });
  }
  navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.startsWith('#')) { e.preventDefault(); var t = document.querySelector(href); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
